module.exports = __webpack_public_path__ + "static/media/sculptor.53f3f446.png";